module.exports = __webpack_public_path__ + "img/31.3b025c18.jpeg";